import React from 'react';
import {Card, Col, Tab, Tabs} from "react-bootstrap";
import Row from "react-bootstrap/Row";
import VirtUserLogsInDashboard from "./VirtUserLogsInDashboard";
import TransferVirtToFriend from "./TransferVirtToFriend";
import BuyVirtOnStock from "./BuyVirtOnStock";
import SellVirtOnStock from "./SellVirtOnStock";
import VirtalibryPromoBounty from "./VirtalibryPromoBounty";

const VirtBalanceLogsInDashboard = () => {
    const [key, setKey] = React.useState('virtlogs');
    const [refreshKeys, setRefreshKeys] = React.useState({
        virtlogs: 0,
        buyvirt: 0,
        sellvirt: 0,
        transfer: 0,
    });

    const handleSelect = (nextKey) => {
        setKey(nextKey);
        setRefreshKeys((prev) => ({
            ...prev,
            [nextKey]: (prev[nextKey] || 0) + 1,
        }));
    };

    return (
        <Card className="p-2 w-100 mt-2">
            <Row className="p-2">

                <Col>
                    <Tabs activeKey={key} onSelect={handleSelect} className="mb-3 nav-success" >
                        <Tab eventKey="virtlogs" title="Balance Logs" className="">

                            <VirtUserLogsInDashboard refreshKey={refreshKeys.virtlogs} />
                        </Tab>
                        <Tab eventKey="virtalibryPromo" title="Earn More Virt">
                            <VirtalibryPromoBounty />
                        </Tab>

                        <Tab eventKey="buyvirt" title="Buy Virt">
                            <BuyVirtOnStock refreshKey={refreshKeys.buyvirt} />
                        </Tab>

                        <Tab eventKey="sellvirt" title="Sell Your Virt">
                            <SellVirtOnStock refreshKey={refreshKeys.sellvirt} />
                        </Tab>


                        <Tab eventKey="transfer" title="Transfer Virt">
                            <TransferVirtToFriend refreshKey={refreshKeys.transfer} />
                        </Tab>
                    </Tabs>
                </Col>
            </Row>
        </Card>
    );
};

export default VirtBalanceLogsInDashboard;
